import { createAction } from 'redux-actions';

import types from './types';

const _loadCart = createAction(types.LOAD_CART_DATA);
const loadCart = payload => _loadCart({ ...payload });

const setCartData = createAction(types.SET_CART_DATA);
const mergeCart = createAction(types.MERGE_CART);
const removeFromCart = createAction(types.REMOVE_FROM_CART);
const setLoading = createAction(types.SET_LOADING);
const addToCart = createAction(types.ADD_TO_CART);
const updateCart = createAction(types.UPDATE_CART);
const addOrUpdateCart = createAction(types.ADD_OR_UPDATE_CART);
const updateCartComplete = createAction(types.UPDATE_CART_COMPLETE);
const removeItemComplete = createAction(types.REMOVE_ITEM_COMPLETE);
const setHasLowStock = createAction(types.SET_HAS_LOW_STOCK);
const cartBeenMerged = createAction(types.CART_BEEN_MERGED);
const setHaveOutOfStock = createAction(types.SET_HAVE_OUT_OF_STOCK);
const setOutOfStockEntriesNumber = createAction(types.SET_OUT_OF_STOCK_ENTRIES_NUMBER);
const checkRedirect = createAction(types.CHECK_REDIRECT);

const _initialize = createAction(types.INITIALIZE);
const initialize = ({ cleanData }) => _initialize({ cleanData });

const setCode = createAction(types.SET_CODE);
const setGuid = createAction(types.SET_GUID);

const _setDataAttr = createAction(types.SET_DATA_ATTR);
const setDataAttr = (name, value) => _setDataAttr({ name, value });

const _setEmailAddress = createAction(types.SET_EMAIL_ADDRESS);
const setEmailAddress = email => _setEmailAddress({ email });

const _forceCartCodeChange = createAction(types.FORCE_CART_CODE_CHANGE);
const forceCartCodeChange = code => _forceCartCodeChange({ code });

const _forceOutOfStock = createAction(types.FORCE_OUT_OF_STOCK);
const forceOutOfStock = (code, quantity) => _forceOutOfStock({ code, quantity });

const _stockLevelList = createAction(types.STOCK_LEVEL_LIST);
const stockLevelList = code => _stockLevelList(code);

const setStockValidation = createAction(types.SET_STOCK_VALIDATION);
const _deleteStockLevelList = createAction(types.DELETE_STOCK_LEVEL_LIST);
const deleteStockLevelList = () => _deleteStockLevelList();
const clearDeliveryAddress = createAction(types.CLEAR_DELIVERY_ADRESS);
const clearHasLowStock = createAction(types.CLEAR_HAS_LOW_STOCK);
const setLowStockItems = createAction(types.SET_LOW_STOCK_ITEMS);
const removeFromLowStockItems = createAction(types.REMOVE_FROM_LOW_STOCK_ITEMS);
const adjustCart = createAction(types.ADJUST_CART);
const limitativeBrands = createAction(types.LIMITATIVE_BRANDS);
const setLimitativeBrands = createAction(types.SET_LIMITATIVE_BRANDS);
const resetLimitativeBrands = createAction(types.RESET_LIMITATIVE_BRANDS);
const setCheckLimitativeBrands = createAction(types.CHECK_LIMITATIVE_BRANDS);
const loadOverlimitedBrands = createAction(types.LOAD_OVERLIMITED_BRANDS);
const setOverlimitedBrands = createAction(types.SET_OVERLIMITED_BRANDS);
const setAdjustedCartData = createAction(types.SET_ADJUSTED_CART_DATA);
const resetAdjustedCartData = createAction(types.RESET_ADJUSTED_CART_DATA);
const checkAddresses = createAction(types.CHECK_ADDRESSES);
const checkAddressesComplete = createAction(types.CHECK_ADDRESSES_COMPLETE);
const setIsProductsBeenMerged = createAction(types.SET_IS_PRODUCTS_BEEN_MERGED);
const setEgiftCardCartActive = createAction(types.SET_EGIFTCARD_CART_ACTIVE);
const setEGiftCardCode = createAction(types.SET_EGIFT_CARD_CODE);
const restoreRegularCart = createAction(types.RESTORE_REGULAR_CART);
const setRegularCartId = createAction(types.SET_REGULAR_CART_ID);

const loadHomeDeliveryDate = createAction(types.LOAD_HOME_DELIVERY_DATE);
const loadCCExpressDeliveryDate = createAction(types.LOAD_CLICK_AND_COLLECT_EXPRESS_DELIVERY_DATE);
const loadCCTraditionalDeliveryDate = createAction(types.LOAD_CLICK_AND_COLLECT_DELIVERY_DATE);
const loadPostPointDeliveryDate = createAction(types.LOAD_POST_POINT_DELIVERY_DATE);
const setHomeDeliveryDate = createAction(types.SET_HOME_DELIVERY_DATE);
const setCCExpressDeliveryDate = createAction(types.SET_CLICK_AND_COLLECT_EXPRESS_DELIVERY_DATE);
const setCCTraditionalDeliveryDate = createAction(
    types.SET_CLICK_AND_COLLECT_TRADITIONAL_DELIVERY_DATE,
);
const setPostPointDeliveryDate = createAction(types.SET_POST_POINT_DELIVERY_DATE);

const toggleVoucherOnCart = createAction(types.TOGGLE_VOUCHER_ON_CART);
const setLoaded = createAction(types.SET_LOADED);
const voucherIsLoading = createAction(types.VOUCHER_IS_LOADING);
const persistGwpProductCodes = createAction(types.PERSIST_GWP_PRODUCT_CODES);

const selectGwp = createAction(types.SELECT_GWP);
const updateSelectedGwp = createAction(types.UPDATE_SELECTED_GWP_ITEM);
const removeBillingAddress = createAction(types.REMOVE_BILLING_ADDRESS);
const removeBillingAddressSuccess = createAction(types.REMOVE_BILLING_ADDRESS_SUCCESS);

const setTemporaryAddress = createAction(types.SET_TEMPORARY_ADDRESS);

const setAddToCartError = createAction(types.SET_ADD_TO_CART_ERROR);
const setRemoveFromCartError = createAction(types.SET_REMOVE_FROM_CART_ERROR);

const setDeliveryAddress = createAction(types.SET_DELIVERY_ADDRESS);
const setPaymentAddress = createAction(types.SET_PAYMENT_ADDRESS);
const setLoyaltyChequesMessage = createAction(types.SET_LOYALTY_CHEQUES_MESSAGE);

const checkForbiddenEntriesInStock = createAction(types.CHECK_FORBIDDEN_ENTRIES_IN_STOCK);

const openSwipeToBuyDialog = createAction(types.OPEN_SWIPE_TO_BUY_DIALOG);
const closeSwipeToBuyDialog = createAction(types.CLOSE_SWIPE_TO_BUY_DIALOG);
const deleteCart = createAction(types.DELETE_CART);
const managePostProcessForSwipeToBuy = createAction(types.MANAGE_POST_PROCESS_FOR_SWIPE_TO_BUY);
const restoreOldCartId = createAction(types.RESTORE_OLD_CART);
const createCart = createAction(types.CREATE_CART);

const bulkAddToCart = createAction(types.BULK_ADD_TO_CART);
const deleteCartComplete = createAction(types.DELETE_CART_COMPLETE);
const swipeToBuyRedirect = createAction(types.SWIPE_TO_BUY_REDIRECT);
const swipeToBuyCloseProcessed = createAction(types.SWIPE_TO_BUY_CLOSE_PROCESSED);
const requestBundleReferences = createAction(types.REQUEST_BUNDLE_REFERENCES);
const setMaxAllowedExceeded = createAction(types.SET_MAX_ALLOWED_PRODUCT_EXCEEDED);

export default {
    loadCart,
    mergeCart,
    setCartData,
    setLoading,
    addToCart,
    updateCart,
    addOrUpdateCart,
    setHasLowStock,
    setDataAttr,
    setEmailAddress,
    removeFromCart,
    initialize,
    setCode,
    setEGiftCardCode,
    setEgiftCardCartActive,
    restoreRegularCart,
    setGuid,
    forceCartCodeChange,
    cartBeenMerged,
    updateCartComplete,
    forceOutOfStock,
    setHaveOutOfStock,
    setOutOfStockEntriesNumber,
    stockLevelList,
    deleteStockLevelList,
    setStockValidation,
    removeItemComplete,
    checkRedirect,
    clearDeliveryAddress,
    clearHasLowStock,
    setLowStockItems,
    removeFromLowStockItems,
    adjustCart,
    limitativeBrands,
    setLimitativeBrands,
    resetLimitativeBrands,
    setCheckLimitativeBrands,
    loadOverlimitedBrands,
    setOverlimitedBrands,
    setAdjustedCartData,
    resetAdjustedCartData,
    checkAddresses,
    checkAddressesComplete,
    setIsProductsBeenMerged,
    setRegularCartId,
    voucherIsLoading,
    toggleVoucherOnCart,
    setLoaded,
    persistGwpProductCodes,
    selectGwp,
    updateSelectedGwp,
    loadHomeDeliveryDate,
    loadCCTraditionalDeliveryDate,
    loadCCExpressDeliveryDate,
    loadPostPointDeliveryDate,
    setHomeDeliveryDate,
    setCCExpressDeliveryDate,
    setCCTraditionalDeliveryDate,
    setPostPointDeliveryDate,
    setAddToCartError,
    setRemoveFromCartError,
    removeBillingAddress,
    removeBillingAddressSuccess,
    setTemporaryAddress,
    setDeliveryAddress,
    setPaymentAddress,
    checkForbiddenEntriesInStock,
    setLoyaltyChequesMessage,
    openSwipeToBuyDialog,
    closeSwipeToBuyDialog,
    deleteCart,
    deleteCartComplete,
    restoreOldCartId,
    managePostProcessForSwipeToBuy,
    createCart,
    bulkAddToCart,
    swipeToBuyRedirect,
    swipeToBuyCloseProcessed,
    requestBundleReferences,
    setMaxAllowedExceeded,
};
